export const ROOT_PATH = '/';
export const LOGIN_REDIRECT = `${ROOT_PATH}login-redirect`;
export const DASHBOARD_PATH = `${ROOT_PATH}dashboard`;

export const LOGIN_PATH = `${ROOT_PATH}login`;

export const SIGNUP_PATH = `${ROOT_PATH}signup`;

//User
export const USER_LIST_VIEW_PATH = `${ROOT_PATH}user-list`;
export const USER_VIEW_PATH = `${ROOT_PATH}user-info`;
export const ADD_USER_PATH = `${ROOT_PATH}add-user`;
export const EDIT_USER_PATH = `${ROOT_PATH}edit-user`;
export const USER_PROFILE_PATH = `${ROOT_PATH}user-profile`;

//restaurant owner
export const RESTAURANT_OWNER_LIST_VIEW_PATH = `${ROOT_PATH}restaurant-owner-list`;

//personal restaurant
export const PERSONAL_RESTAURANT_LIST_VIEW_PATH = `${ROOT_PATH}personal-restaurant-list`;
export const EDIT_PERSONAL_RESTAURANT_PATH = `${ROOT_PATH}edit-personal-restaurant`;

//Role
export const ROLE_LIST_VIEW_PATH = `${ROOT_PATH}role-list`;
export const ADD_ROLE_PATH = `${ROOT_PATH}add-role`;
export const EDIT_ROLE_PATH = `${ROOT_PATH}edit-role`;

//table layout
export const TABLE_LAYOUT_LIST_VIEW = `${ROOT_PATH}table-layout-list`;
export const ADD_TABLE_LAYOUT = `${ROOT_PATH}add-table-layout`;
export const EDIT_TABLE_LAYOUT = `${ROOT_PATH}edit-table-layout`;

//floor
export const FLOOR_MANAGEMENT_PATH = `${ROOT_PATH}floor-management`;
export const ADD_FLOOR_LAYOUT_PATH = `${ROOT_PATH}add-floor-layout`;

//schedule
export const SCHEDULE_LIST_VIEW_PATH = `${ROOT_PATH}schedule-list`;
export const ADD_SCHEDULE_PATH = `${ROOT_PATH}add-schedule`;
export const EDIT_SCHEDULE_PATH = `${ROOT_PATH}edit-schedule`;

//restaurant
export const RESTAURANT_LIST_VIEW_PATH = `${ROOT_PATH}restaurant-list`;
export const ADD_RESTAURANT_PATH = `${ROOT_PATH}add-restaurant`;
export const EDIT_RESTAURANT_PATH = `${ROOT_PATH}edit-restaurant`;

// restaurant profile
export const RESTAURANT_PROFILE_PATH = `${ROOT_PATH}restaurant-profile`;

// restaurant config
export const RESTAURANT_CONFIG_LIST_VIEW_PATH = `${ROOT_PATH}restaurant-config-list`;
export const ADD_RESTAURANT_CONFIG_PATH = `${ROOT_PATH}add-restaurant-config`;
export const EDIT_RESTAURANT_CONFIG_PATH = `${ROOT_PATH}edit-restaurant-config`;

//token config
export const RESTAURANT_TOKEN_CONFIG_PATH = `${ROOT_PATH}config-restaurant-token`

//reserve
export const RESERVE_LIST_VIEW_PATH = `${ROOT_PATH}reserve-list`;
export const RESERVE_MANAGEMENT_PATH = `${ROOT_PATH}reserve-management`;
export const CREATE_RESERVE_PATH = `${ROOT_PATH}create-reserve`;

//customers
export const CUSTOMER_LIST_VIEW_PATH = `${ROOT_PATH}customer-list`;

//special off day
export const SPECIAL_OFF_DAY_LIST_PATH = `${ROOT_PATH}special-off-day-list`;
export const ADD_SPECIAL_OFF_DAY = `${ROOT_PATH}add-special-off-day`;
export const EDIT_SPECIAL_OFF_DAY = `${ROOT_PATH}edit-special-off-day`;

//otp
export const OTP_VERIFY_PATH = `${ROOT_PATH}otp-verify`;

//reset password
export const RESET_PASSWORD_PATH = `${ROOT_PATH}reset-password`;
export const RESET_PASSWORD_OTP_VERIFY_PATH = `${ROOT_PATH}reset-password-otp-verify`;

//Error Page
export const PAGE_403_PATH = `${ROOT_PATH}403`;
export const PAGE_404_PATH = `${ROOT_PATH}404`;
export const PAGE_500_PATH = `${ROOT_PATH}500`;
